/** @type {import("@mui/material").ThemeOptions} */
const baseThemeOptions = {
  components: {
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "36px",
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          ":last-child": {
            paddingBottom: "16px",
          },
        },
      },
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          overflowX: "auto",
        },
      },
    },
  },
};

// agent-ntfy palette: indigo/violet primary with a cyan accent

/** @type {import("@mui/material").ThemeOptions} */
export const lightTheme = {
  ...baseThemeOptions,
  components: {
    ...baseThemeOptions.components,
  },
  palette: {
    mode: "light",
    primary: {
      main: "#4f46e5",
    },
    secondary: {
      main: "#22d3ee",
    },
    error: {
      main: "#c30000",
    },
  },
};

/** @type {import("@mui/material").ThemeOptions} */
export const darkTheme = {
  ...baseThemeOptions,
  components: {
    ...baseThemeOptions.components,
    MuiSnackbarContent: {
      styleOverrides: {
        root: {
          color: "#000",
          backgroundColor: "#aeaeae",
        },
      },
    },
  },
  palette: {
    mode: "dark",
    background: {
      paper: "#1a1930",
    },
    primary: {
      main: "#a5b4fc",
    },
    secondary: {
      main: "#22d3ee",
    },
    error: {
      main: "#fe4d2e",
    },
  },
};
